import { TSectionName } from './types';

/**
 * Wedding Website Section Names
 *
 * Centralized constants for all website section names (the ones used in data model)
 * Used by TSectionName type in ./types.ts
 */
export const SECTION_NAMES = {
  PRIMARY_VENUE: 'primaryVenue',
  PRIMARY_PHOTOS: 'primaryPhotos',
  OUR_STORY: 'ourStory',
  FAQ: 'faq',
  GIFT_LIST: 'giftList',
  HOTELS: 'hotels',
  SCHEDULE: 'schedule',
  COUPLE_NAMES: 'coupleNames',
  WEDDING_DATE: 'weddingDate',
  RSVP: 'rsvp',
} as const;

/**
 * Non-reorderable sections (fixed at top)
 */
export const NON_REORDERABLE_SECTIONS: readonly TSectionName[] = [
  SECTION_NAMES.COUPLE_NAMES,
  SECTION_NAMES.WEDDING_DATE,
  SECTION_NAMES.RSVP,
  SECTION_NAMES.PRIMARY_PHOTOS,
] as const;

/**
 * Sections that support visibility toggling
 */
export const VISIBILITY_TOGGLEABLE_SECTIONS: readonly TSectionName[] = [
  SECTION_NAMES.OUR_STORY,
  SECTION_NAMES.FAQ,
  SECTION_NAMES.GIFT_LIST,
  SECTION_NAMES.HOTELS,
  SECTION_NAMES.SCHEDULE,
  SECTION_NAMES.PRIMARY_VENUE,
  SECTION_NAMES.RSVP,
] as const;
